// extracted by mini-css-extract-plugin
export var quillEditor = "_lu-1";
export var variable = "_lu-0";